<template>
  <header>
        <div class="col-xs-7 col-sm-3">
          <logo :color="logoColor" />
        </div>
  </header>
</template>

<script>
import Logo from "../components/Logo.vue";

export default {
  name: "Header",
  components: {
    Logo,
  },
  data() {
    return {
      logoColor: "#FFFFFF",
      menu: null,
      submenu: null,
      iconsState: "",
      iconsTitle: "",
    };
  },
};
</script>

<style lang="scss">
@import "../../core/core-framework/assets/scss/inc/_variables.scss";
@import "../../core/core-framework/assets/scss/inc/_bootstrap_custom_variables.scss";

header {
  position: relative;
  z-index: 2;
  background: $color-blue-02;
  color: $color-white;
  .logo {
    padding: 8px 0;
    @media (min-width: $screen-sm) {
      padding: 40px 60px 41px;
    }
  }
  .menu-wrapper.whole {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row-reverse;
    @media (min-width: $screen-lg) {
      justify-content: flex-end;
      flex-direction: row;
      min-height: 99px;
    }
    @media (max-width: $screen-lg) {
      margin: 24px 0;
    }
    @media (max-width: $screen-sm) {
      margin: 8px 0;
    }
    #login-trigger {
      @media (min-width: $screen-sm) {
        position: relative;
      }
    }
  }
}
</style>
